import { map } from 'lodash'
import {NotificationManager} from 'react-notifications'

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'

export function setErrorMessage(error) {
    return {
        type: SET_ERROR_MESSAGE,
        error_message: error
    }
}

export function clearErrorMessage() {
    return setErrorMessage(null)
}

export function getSubmissionErrors(json) {
    const submission_errors = {}
    map(json, (error, field_name) => {
        if (field_name !== 'non_field_errors') {
            submission_errors[field_name] = error
        } else {
            submission_errors['_error'] = error
        }
    })
    return submission_errors
}

export function showSuccess(msg, sub_msg) {
    NotificationManager.success(sub_msg, msg)
}

export function showError(msg, sub_msg, ex) {
    NotificationManager.error(sub_msg, msg)
}

